import $ from 'jquery';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Route, HashRouter as Router, Switch, withRouter } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import CookieConsent from './components/CookieConsent';
import Sidebar from './components/layouts/Sidebar';
import AutoRegistrationContainer from './containers/AutoRegistrationContainer';
import BalanceCashlessContainer from './containers/BalanceCashlessContainer';
import BalanceContainer from './containers/BalanceContainer';
import BalancePrepaidContainer from './containers/BalancePrepaidContainer';
import CardDetailsContainer from './containers/CardDetailsContainer';
import CardMobileUserContainer from './containers/CardMobileUserContainer';
import CardOrderContainer from './containers/CardOrderContainer';
import CardOrdersDraftListContainer from './containers/CardOrdersDraftListContainer';
import ChangePasswordContainer from './containers/ChangePasswordContainer';
import ContactContainer from './containers/ContactContainer';
import CookiesContainer from './containers/CookiesContainer';
import DriverVehicleList from './containers/DriverVehicleList';
import HelpContainer from './containers/HelpContainer';
import InvoiceDownloadContainer from './containers/InvoiceDownloadContainer';
import InvoiceListContainer from './containers/InvoiceListContainer';
import InvoiceP24ReturnContainer from './containers/InvoiceP24ReturnContainer';
import InvoicePragmaReturnContainer from './containers/InvoicePragmaReturnContainer';
import Login from './containers/LoginContainer';
import ManageAccountContainer from './containers/ManageAccountContainer';
import OrderDraftsListContainer from './containers/OrderDraftsListContainer';
import OrderFuelContainer from './containers/OrderFuelContainer';
import ProfileContainer from './containers/ProfileContainer';
import RemindPasswordContainer from './containers/RemindPasswordContainer';
import ReportListContainer from './containers/ReportListContainer';
import SettingsContainer from './containers/SettingsContainer';
import StartContainer from './containers/StartContainer';
import StationsMapContainer from './containers/StationsMapContainer';
import TransactionListContainer from './containers/TransactionListContainer';
import UserDetailsContainer from './containers/UserDetailsContainer';
import VersionContainer from './containers/VersionContainer';
import AccountService from './services/AccountService';
import AuthService from './services/AuthService';
import SettingService from './services/SettingService';
import UserService from './services/UserService';
import withAuth from './utils/withAuth';
import AutoRegistrationByBankContainer from './containers/AutoRegistrationByBankContainer';
import AdditionalServicesContainer from './containers/AdditionalServicesContainer';

class App extends Component {
    ws = new ReconnectingWebSocket(process.env.REACT_APP_BACKEND_WS_URL + '/ws-notification');

    constructor() {
        super();
        this.authService = new AuthService();
        this.userService = new UserService();
        this.settingService = new SettingService();
        this.accountService = new AccountService();
        this.state = {
            user: this.authService.getProfile(),
            collapsed: false,
            toggled: false,
            renderSidebar: true,
            hdUsers: [],
        };
        this.handleLogoutUser = this.handleLogoutUser.bind(this);
        this.handleHideMenu = this.handleHideMenu.bind(this);
        this.handleShowMenu = this.handleShowMenu.bind(this);
        this.setActiveMenu = this.setActiveMenu.bind(this);
        this.webSocket = React.createRef();
        this.handleFilterCbk = this.handleFilterCbk.bind(this); 
        this.getHelpDeskUsers = this.getHelpDeskUsers.bind(this); 
        this.handleSwitchCbk = this.handleSwitchCbk.bind(this);
    }

    componentDidMount() {  
        this.settingService.getValue('SUPPORTED_LANGUAGES').then((res) => {
            localStorage.setItem('supportedLanguages', res.value);
        });
        this.ws.onopen = () => {
            // on connecting, do nothing but log it to the console
            if (this.authService.getToken()) {
                this.ws.send(
                    JSON.stringify({
                        operation: 'REGISTER',
                        token: this.authService.getToken(),
                    })
                );
            }
        };

        this.ws.onmessage = (evt) => {
            // listen to data sent from the websocket server
            const message = JSON.parse(evt.data);
            if(!(this.authService.getProfile().helpdeskUserRole === 'BANK_SGB' || this.authService.getProfile().helpdeskUserRole === 'BANK_BPS')){
                this.setState({dataFromServer: message});
                // console.log(message);
            }
        };

        this.ws.onclose = () => {
            // automatically try to reconnect on connection loss
        };
    }

    setActiveMenu(activeUrl) {
        if (activeUrl !== this.state.activeUrl) {
            this.setState({activeUrl});
        }
    }
    handleHideMenu() {
        if (!!this.state.renderSidebar) {
            this.setState({renderSidebar: false});
        }
    }

    handleShowMenu() {
        if (!this.state.renderSidebar) {
            this.setState({renderSidebar: true});
        }
    }

    handleToggleSidebar() {
        this.setState((prevState) => ({toggled: !prevState.toggled}));
    }

    handleCollapsedChange() {
        this.setState(
            (prevState) => ({collapsed: !prevState.collapsed}),
            () => {
                if (this.state.collapsed) {
                    $('.pro-sidebar-inner').css('position', 'relative');
                } else {
                    $('.pro-sidebar-inner').css('position', 'fixed');
                }
            }
        );
    }

    handleLogoutUser(url) {
        this.authService.logout();
        if (!!url && typeof url === 'string') {
            window.location.href = '/#login?location=' + url;
        } else {
            window.location.href = '/#/login?force=true';
        }
        if (this.state.user) {
            this.setState({user: null});
        }
    }

    getHelpDeskUsers() {
        let hdUsers = null;
        this.accountService
            .getHelpDeskUsers()
            .then((helpDeskUsers) =>
            {this.setState({hdUsers: helpDeskUsers});
            hdUsers = helpDeskUsers;
        } ) 
        .catch(() => {
        });
            return hdUsers;
    }


    handleSwitchCbk(cbkNr) {
           this.authService.switchCbk(cbkNr)
                .then((res) => {
                            window.location.reload();
                            window.location.href = '/#/start';
                })
                ;
    }
    
    handleFilterCbk() {
     let hdUsers =  this.getHelpDeskUsers;
        return hdUsers;
    }

    render() {
        const authService = this.authService;
        return (
            <React.Fragment>
                <CookieConsent
                    location='bottom'
                    buttonText='Akceptuję'
                    cookieName='cookiePolicy'
                    style={{background: 'rgba(0, 0, 0, 0.8)'}}
                    buttonStyle={{
                        background: '#1c3275',
                        color: 'white',
                        fontSize: '16px',
                        fontFamily: 'Ubuntu',
                        fontWeight: 500,
                        borderRadius: '3px',
                    }}
                    expires={150}
                >
                    Nasz serwis wykorzystuje pliki cookies. Możesz zrezygnować ze zbierania informacji poprzez pliki cookies, zmieniając
                    ustawienia Twojej przeglądarki - w takim przypadku nie gwarantujemy poprawnego działania serwisu.
                </CookieConsent>
                <Router>
                    <div className={!authService.loggedIn() && !!this.state.renderSidebar ? 'app' : 'app logged'}>
                        {!!authService.loggedIn() && !!this.state.renderSidebar ? (
                            <div>
                                <div className='sidebar-vertical'>
                                    <Sidebar
                                        collapsed={this.state.collapsed}
                                        toggled={this.state.toggled}
                                        loggedUser={this.state.user}
                                        handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                        handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                        handleLogoutUser={this.handleLogoutUser.bind(this)}
                                        authService={this.authService}
                                        accountService={this.accountService}
                                        submenu={undefined}
                                        activeUrl={this.state.activeUrl}
                                       // allCbk={this.handleFilterCbk.bind(this)}
                                      // allCbk={this.state.hdUsers}
                                      // handleChangeCbk={this.handleSwitchCbk.bind(this)}
                                    />
                                </div>

                                <div className='sidebar-horizontal'>
                                    <Sidebar
                                        collapsed={this.state.collapsed}
                                        toggled={this.state.toggled}
                                        loggedUser={this.state.user}
                                        handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                        handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                        handleLogoutUser={this.handleLogoutUser.bind(this)}
                                        authService={this.authService}
                                        accountService={this.accountService}
                                        userService={this.userService}
                                        submenu={true}
                                        activeUrl={this.state.activeUrl}
                                        allCbk={this.state.hdUsers}
                                        //allCbk={this.handleFilterCbk.bind(this)}                                     
                                        handleChangeCbk={
                                            this.handleSwitchCbk.bind(this)}
                                        
                                    />
                                </div>
                            </div>
                        ) : null}
                        <main>
                            {/* <div className={`${authService.loggedIn() ? 'container-fluid' : ''}`}> */}
                            <Switch>
                                <Route
                                    exact
                                    path='/'
                                    render={(props) => (
                                        <Login
                                            {...props}
                                            onAfterLogin={() => {
                                                this.ws.send(
                                                    JSON.stringify({
                                                        operation: 'REGISTER',
                                                        token: this.authService.getToken(),
                                                    })
                                                );
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                        />
                                    )}
                                />
                                <Route
                                    path='/login'
                                    render={(props) => (
                                        <Login
                                            {...props}
                                            onAfterLogin={() => {
                                                this.ws.send(
                                                    JSON.stringify({
                                                        operation: 'REGISTER',
                                                        token: this.authService.getToken(),
                                                    })
                                                );
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/start'
                                    component={withAuth(
                                        this.ws,
                                        StartContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL', 'ROLE_DRIVER'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        (  this.authService.getProfile().helpdeskUserRole === 'HELPDESK'  || 
                                        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' || 
                                        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || 
                                        this.authService.getProfile().helpdeskUserRole === 'HOTLINE'
                                     )
                                        ? 'helpdesk-start-white-style' : 'non-helpdesk-start-white-style',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'start'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/help-page'
                                    component={withAuth(
                                        this.ws,
                                        HelpContainer,
                                        'VIEW',
                                        ['ROLE_ADMIN', 'ROLE_DISPATCHER'],
                                        undefined,
                                        this.handleLogoutUser
                                    )}
                                />
                                <Route exact path='/cookies-page' component={CookiesContainer} />
                                <Route
                                    exact
                                    path='/invoice-list'
                                    component={withAuth(
                                        this.ws,
                                        InvoiceListContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        ['PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES'],
                                        this.handleLogoutUser,
                                        'invoice.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'invoice-list'
                                    )}
                                />
                                <Route
                                    path='/manage-account'
                                    component={withAuth(
                                        this.ws,
                                        ManageAccountContainer,
                                        'EDIT',
                                        ['ROLE_ADMIN', 'ROLE_DISPATCHER'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'manage-account'
                                    )}
                                />
                                <Route path='/version' render={(props) => <VersionContainer handleHideMenu={this.handleHideMenu} />} />
                                <Route
                                    exact
                                    path='/transaction-list'
                                    component={withAuth(
                                        this.ws,
                                        TransactionListContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS'],
                                        this.handleLogoutUser,
                                        'transaction.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'transaction-list', 
                                        undefined,
                                        {webSocket: this.ws}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/drivers-list'
                                    component={withAuth(
                                        this.ws,
                                        DriverVehicleList,
                                        'VIEW',
                                        ['ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        undefined,
                                        this.handleLogoutUser,
                                        'sidebar.driversAndVehicles',
                                        'driver-list-header',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'drivers-list'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/profile'
                                    component={withAuth(
                                        this.ws,
                                        ProfileContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        ['PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE'],
                                        this.handleLogoutUser,
                                        'profile.label',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'profile'
                                    )}
                                />
                                  <Route
                                    exact
                                    path='/additional-services'
                                    component={withAuth(
                                        this.ws,
                                        AdditionalServicesContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES'],
                                        this.handleLogoutUser,
                                        'additionalServices.label',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'additional-services'
                                    )}
                                />
                                {/* <Route
                                    exact
                                    path='/faq'
                                    component={withAuth(this.ws,
                                        FaqContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_DRIVER'],
                                        undefined,
                                        this.handleLogoutUser,
                                        'header.faq',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'faq'
                                    )}
                                /> */}
                                <Route
                                    exact
                                    path='/cards'
                                    component={withAuth(
                                        this.ws,
                                        CardMobileUserContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS'],
                                        this.handleLogoutUser,
                                        'cards.title',
                                        'cards-title-header',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'cards'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/user-details/:num'
                                    component={withAuth(
                                        this.ws,
                                        UserDetailsContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS'],
                                        this.handleLogoutUser,
                                        'cards.backLinkLabel',
                                        'user-details-container-header',
                                        '/#/cards',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'cards'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/card-details/:id'
                                    component={withAuth(
                                        this.ws,
                                        CardDetailsContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS'],
                                        this.handleLogoutUser,
                                        'cards.backLinkLabel',
                                        'card-details-header',
                                        '/#/cards',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'cards'
                                    )}
                                />
                                <Route exact path='/autoregistration' component={AutoRegistrationContainer} />
                                 {/* <Route exact path='/bank-autoregistration' component={AutoRegistrationByBankContainer} xd= {'XDDDD'}/> */}
                                <Route
                                    exact
                                    path='/bank-start-page'
                                    component={withAuth(
                                        this.ws,
                                        AutoRegistrationByBankContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL', 'ROLE_DRIVER'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'bank-external-worker',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'bank-start-page'
                                    )}
                                />
                                 {/* <Route
                                    exact
                                    path='/bank-start-page'
                                    render={(props) => (
                                        <AutoRegistrationByBankContainer
                                            formType={"START"}
                                            {...props}

                                        />
                                    )}
                                /> */}
                                <Route
                                    exact
                                    path='/bank-pre-autoregistration'
                                    component={withAuth(
                                        this.ws,
                                        AutoRegistrationByBankContainer,
                                        'VIEW',
                                        undefined,
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'bank-external-worker',
                                        undefined,
                                        false,
                                        undefined,
                                        undefined,
                                        'bank-pre-autoregistration',
                                        undefined,
                                        {formType:"FIRST", hideBankWelcome: true, hideLogout: true}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/bank-autoregistration'
                                    component={withAuth(
                                        this.ws,
                                        AutoRegistrationByBankContainer,
                                        'VIEW',
                                        undefined,
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'bank-external-worker',
                                        undefined,
                                        false,
                                        undefined,
                                        undefined,
                                        'bank-autoregistration',
                                        undefined,
                                        {formType:"SECOND", hideBankWelcome: true, hideLogout: true}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/map'
                                    component={withAuth(
                                        this.ws,
                                        StationsMapContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL', 'ROLE_DRIVER'],
                                        ['PERMISSION_FULL_ACCESS_STATIONS_MAP'],
                                        this.handleLogoutUser,
                                        'stationsMap.title',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'map'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-new'
                                    component={withAuth(
                                        this.ws,
                                        OrderFuelContainer,
                                        'NEW',
                                        ['ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        undefined,
                                        true,
                                        this.handleHideMenu,
                                        this.setActiveMenu,
                                        'orders'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-fuel-again/:id'
                                    component={withAuth(
                                        this.ws,
                                        OrderFuelContainer,
                                        'EDIT',
                                        ['ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        '/#/orders',
                                        true,
                                        this.handleHideMenu
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-fuel-template-edit/:id'
                                    component={withAuth(
                                        this.ws,
                                        OrderFuelContainer,
                                        'EDIT',
                                        ['ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        undefined,
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        '/#/orders',
                                        true,
                                        this.handleHideMenu,
                                        undefined,
                                        undefined,
                                        undefined,
                                        {templateEdit: true}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/orders'
                                    component={withAuth(
                                        this.ws,
                                        OrderDraftsListContainer,
                                        'LIST',
                                        ['ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        undefined,
                                        this.handleLogoutUser,
                                        'sidebar.orders',
                                        'order-fuel-list',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'orders'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/forgot-password'
                                    render={(props) => (
                                        <RemindPasswordContainer
                                            {...props}
                                            onAfterLogin={() => {
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                            type='REMIND'
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/first-login'
                                    render={(props) => (
                                        <RemindPasswordContainer
                                            {...props}
                                            onAfterLogin={() => {
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                            type='FIRST'
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/set-password/:token'
                                    render={(props) => (
                                        <ChangePasswordContainer
                                            {...props}
                                            onAfterLogin={() => {
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-card-new'
                                    component={withAuth(
                                        this.ws,
                                        CardOrderContainer,
                                        'NEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_FULL_ACCESS_ORDERS'],
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        '/#/cards',
                                        true,
                                        this.handleHideMenu,
                                        this.setActiveMenu,
                                        'card-order-list',
                                        'order-card-padding',
                                        {location: this.props.location}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-card-again/:id'
                                    component={withAuth(
                                        this.ws,
                                        CardOrderContainer,
                                        'EDIT',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_FULL_ACCESS_ORDERS'],
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        '/#/card-order-list',
                                        true,
                                        this.handleHideMenu,
                                        false,
                                        undefined,
                                        'order-card-padding',
                                        {template: false}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/order-card-template/:id'
                                    component={withAuth(
                                        this.ws,
                                        CardOrderContainer,
                                        'EDIT',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_FULL_ACCESS_ORDERS'],
                                        this.handleLogoutUser,
                                        undefined,
                                        'no-white-header',
                                        '/#/card-order-list',
                                        true,
                                        this.handleHideMenu,
                                        false,
                                        undefined,
                                        'order-card-padding',
                                        {template: true}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/card-order-list'
                                    component={withRouter(
                                        withAuth(
                                            this.ws,
                                            CardOrdersDraftListContainer,
                                            'LIST',
                                            ['ROLE_FLEET'],
                                            ['PERMISSION_FULL_ACCESS_ORDERS'],
                                            this.handleLogoutUser,
                                            'order-card.listTitle',
                                            'card-order-list-header',
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            'card-order-list'
                                        )
                                    )}
                                />
                                <Route
                                    exact
                                    path='/contact'
                                    component={withAuth(
                                        this.ws,
                                        ContactContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL', 'ROLE_DRIVER'],
                                        undefined,
                                        this.handleLogoutUser,
                                        'contact.title',
                                        'contact-header',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'contact'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/balance'
                                    component={withAuth(
                                        this.ws,
                                        BalanceContainer,
                                        'VIEW',
                                        ['ROLE_FLEET', 'ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL'],
                                        ['PERMISSION_EDIT_START'],
                                        this.handleLogoutUser,
                                        'balance.backLinkLabel',
                                        'balance-details-container-header',
                                        '/#/start',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'start'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/balance-cashless'
                                    component={withAuth(
                                        this.ws,
                                        BalanceCashlessContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_EDIT_START'],
                                        this.handleLogoutUser,
                                        'balance.backLinkLabel',
                                        'balance-cashless-details-container-header',
                                        '/#/start',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'start'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/balance-prepaid'
                                    component={withAuth(
                                        this.ws,
                                        BalancePrepaidContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_EDIT_START'],
                                        this.handleLogoutUser,
                                        'balance.backLinkLabel',
                                        'balance-prepaid-container-header',
                                        '/#/start',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'start'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reports'
                                    component={withAuth(
                                        this.ws,
                                        ReportListContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_REPORTS', 'PERMISSION_EDIT_REPORTS'],
                                        this.handleLogoutUser,
                                        'reports.title',
                                        'reports-header',
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'reports'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/settings'
                                    component={withAuth(
                                        this.ws,
                                        SettingsContainer,
                                        'VIEW',
                                        ['ROLE_FLEET'],
                                        ['PERMISSION_VIEW_SETTINGS', 'PERMISSION_EDIT_SETTINGS'],
                                        this.handleLogoutUser,
                                        'settings.title',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'settings'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/invoice-download/:id'
                                    render={(props) => <InvoiceDownloadContainer invoiceNumber={props.match.params.id} {...props} />}
                                />
                                <Route exact path='/invoice-p24-return' render={(props) => <InvoiceP24ReturnContainer {...props} />} />
                                <Route exact path='/invoice-pragma-return' render={(props) => <InvoicePragmaReturnContainer {...props} />} />
                            </Switch>
                            {/* </div> */}
                        </main>
                    </div>
                </Router>
            </React.Fragment>
        );
    }
}

export default withTranslation()(App);
